import { CSSProperties } from 'react';
import { alpha, Theme } from '@mui/material';

export default {
    container: {
        flexShrink: 0,
        px: 2,
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    // In 7.2.1 the header container was this row, so custom_styles written then align the tabs through
    // `container`; the row follows its justify-content and always spans it.
    row: {
        position: 'relative',
        alignSelf: 'stretch',
        alignItems: 'center',
        justifyContent: 'inherit',
    },
    // The close button sits outside the row flow, so a re-aligned row (e.g. centred tabs) never moves it
    // off the panel's right edge; the tabs keep clear of it instead.
    tabs: {
        minWidth: 0,
        flexShrink: 1,
        maxWidth: (theme: Theme) => `calc(100% - ${theme.size.pxValue(theme.size.defaultHeight)})`,
    },
    closeWrap: {
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    } as CSSProperties,
    chatTab: {
        maxWidth: '220px',
        minWidth: 0,
        flexShrink: 1,
    },
    recentTab: {
        flexShrink: 0,
    },
    context: {
        fontSize: '12px',
        color: 'text.secondary',
        pb: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    closeBtn: {
        width: (theme: Theme) => theme.size.defaultHeight,
        height: (theme: Theme) => theme.size.defaultHeight,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'primary.main',

        '&:hover': {
            opacity: 0.85,
            cursor: 'pointer',
        },
    },
};
